'use client'

import Link from 'next/link'
import Script from 'next/script'
import { useEffect, useState } from 'react'

const InstagramEmbed = ({ url, className }: { url: string, className: string }) => {

    const [isLoaded, setIsLoaded] = useState<boolean>(false)

    useEffect(() => {
    }, [isLoaded])
    
    return <div className={className}>
        <blockquote
            className='instagram-media'
            data-instgrm-permalink={`${url}`}
            data-instgrm-version='14'
            style={{ width: '100%', maxWidth:'540px', margin: '0 auto' }} >
                <Link href={url} target='_blank' prefetch={false}>{url}</Link>
            </blockquote>
        <Script async src='https://www.instagram.com/embed.js' strategy='afterInteractive' onLoad={() => setIsLoaded(true)} />
    </div>
}

export default InstagramEmbed